import { useState } from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Globe, Check } from 'lucide-react';

const LanguageSelector = ({ variant = 'default', showLabel = true }) => {
  const { currentLanguage, setLanguage, supportedLanguages } = useLanguage();
  const [open, setOpen] = useState(false);

  const currentLang = supportedLanguages.find(l => l.code === currentLanguage) || supportedLanguages[0];

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button 
          variant={variant === 'ghost' ? 'ghost' : 'outline'} 
          size={showLabel ? 'default' : 'icon'}
          className={variant === 'ghost' ? 'text-muted-foreground hover:text-foreground' : ''}
          data-testid="language-selector"
        >
          <Globe className="w-4 h-4" />
          {showLabel && (
            <span className="ml-2">
              {currentLang.flag} {currentLang.name}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {supportedLanguages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => {
              setLanguage(lang.code);
              setOpen(false);
            }}
            className="flex items-center justify-between cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <span className="text-lg">{lang.flag}</span>
              <span>{lang.name}</span>
            </span>
            {currentLanguage === lang.code && (
              <Check className="w-4 h-4 text-green-600" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
